export default {
  groups: ["year 6"],
  category: "Named Objects",
  type: "object-named",
};
